import { ReactMarkdown } from "react-markdown/lib/react-markdown"
import { NavLink } from "react-router-dom"
import rehypeRaw from "rehype-raw"
import { Tab } from "../header/navbar"
import "./footer.css"

interface FooterNote { title : string, lines : string[]}


const Footer = (props : { tabs : Tab[], footer_notes : FooterNote[] }) => {
    return <footer>
    <div>
      <h5>Pages</h5>
      {props.tabs.map( (tab,i) => <NavLink key={`pages_footer_${i}`} to={tab.path}>{tab.header}</NavLink>)}
    </div>
    { props.footer_notes.map( (note, i) => <div key={`footer_section_${i}`}>
      <h5>{note.title}</h5>
      {note.lines.map ( (ct, i) => <ReactMarkdown key={`footer_${i}`} rehypePlugins={[rehypeRaw]}>{ct}</ReactMarkdown>)}
    </div>  )
  }
    </footer>
}

export default Footer;
export type { FooterNote }